const bankCodes = [
  { code: '1', description: 'Banco de Chile / Edwards' },
  { code: '2', description: 'Banco Internacional' },
  { code: '3', description: 'Banco Estado' },
  { code: '4', description: 'Scotiabank' },
  { code: '5', description: 'BCI' },
  { code: '6', description: 'CorpBanca' },
  { code: '7', description: 'BICE' },
  { code: '8', description: 'HSBC' },
  { code: '9', description: 'Santander' },
  { code: '10', description: 'Banco Itaú' },
  { code: '11', description: 'Security' },
  { code: '12', description: 'Banco Falabella' },
  { code: '13', description: 'Banco Ripley' },
  { code: '14', description: 'Rabobank' },
  { code: '15', description: 'Banco Consorcio' },
  { code: '16', description: 'Banco Paris' },
  { code: '18', description: 'Banco Del Desarrollo' },
  { code: '19', description: 'Prepago Los Héroes' },
  { code: '21', description: 'Coopeuch' },
  { code: '22', description: 'Tenpo Prepago S.A' },
];

const accountTypes = [
  { code: '20', description: 'Cuenta Corriente' },
  { code: '40', description: 'Cuenta Vista' },
  { code: '10', description: 'Cuenta Ahorro' },
  { code: '1', description: 'Cuenta Prepago' },
];

export { bankCodes, accountTypes };
